export const PREDEFINED_APPS = [
  {
    name: 'Atlassian',
    slugName: 'atlassian',
    description: 'Connect to Jira and Confluence for seamless project management and documentation integration',
    imageUrl: 'https://cdn.worldvectorlogo.com/logos/jira-1.svg'
  },
  {
    name: 'Slack',
    slugName: 'slack',
    description: 'Connect Slack to receive notifications for relevant QA-Path events in your workspace channels',
    imageUrl: 'https://cdn.worldvectorlogo.com/logos/slack-new-logo.svg'
  }
];

export const getAppByName = (name) => {
  return PREDEFINED_APPS.find(app => app.name === name);
};

export const getAppNames = () => {
  return PREDEFINED_APPS.map(app => app.name);
};
